/* eslint-disable camelcase */
import { pushCustomEvent } from './utils';
/**
 * Pushes a custom event action onto the BioTRUST Trackers.js Data Layer
 * specifically to track custom events in GA4
 * @param container
 * @param {boolean} [delegated=false] - If true, the event handler will be delegated to the container
 */

export function registerCustomEventHandler(container) {
  var delegated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  function listener(event) {
    var _event$currentTarget, _event$currentTarget$, _event$currentTarget2, _event$currentTarget3, _event$currentTarget4, _event$currentTarget5;

    var eventName = event === null || event === void 0 ? void 0 : (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 ? void 0 : (_event$currentTarget$ = _event$currentTarget.dataset) === null || _event$currentTarget$ === void 0 ? void 0 : _event$currentTarget$.customEvent;

    if (!eventName) {
      console.warn('No value specified for the data-custom-event attribute on element.', event.target);
      return;
    }

    var eventProperties = {
      collection_handle: event === null || event === void 0 ? void 0 : (_event$currentTarget2 = event.currentTarget) === null || _event$currentTarget2 === void 0 ? void 0 : (_event$currentTarget3 = _event$currentTarget2.dataset) === null || _event$currentTarget3 === void 0 ? void 0 : _event$currentTarget3.collectionHandle,
      product_handle: event === null || event === void 0 ? void 0 : (_event$currentTarget4 = event.currentTarget) === null || _event$currentTarget4 === void 0 ? void 0 : (_event$currentTarget5 = _event$currentTarget4.dataset) === null || _event$currentTarget5 === void 0 ? void 0 : _event$currentTarget5.productHandle
    }; // GA4 limits event names to 40 characters, so take the last 40 characters of the event name

    pushCustomEvent(eventName.substring(eventName.length - 40), 'custom_engage', '', eventProperties);
  }

  if (delegated) {
    $(container).on('click', '[data-custom-event]', listener);
  } else {
    $('[data-custom-event]', container).on('click', listener);
  }
}